import { render } from "./addUser.vue?vue&type=template&id=be782b8c&scoped=true"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=be782b8c&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be782b8c"]])

export default __exports__